import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import RevealDropdown, {
    RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import { Medico, TipoConselho } from 'hooks/useMedicos';
import { Link } from 'react-router-dom';

const getTipoConselhoLabel = (tipo: TipoConselho) => {
    return Object.keys(TipoConselho).find(key => TipoConselho[key as keyof typeof TipoConselho] === tipo) || '';
}

export const medicoTableColumns: ColumnDef<Medico>[] = [
    {
        accessorKey: 'codigo',
        header: 'Código',
        meta: {
            headerProps: { style: { width: 100 }, className: 'ps-4' },
            cellProps: {
                className: 'fs-9 fw-semibold ps-4 text-body-tertiary text-opacity-85'
            }
        }
    },
    {
        accessorKey: 'nome',
        header: 'Nome',
        cell: ({ row: { original } }) => {
            const { nome, id } = original;
            return (
                <Link
                    to={`/cadastros/medicos/${id}`}
                    className="fw-semibold line-clamp-3"
                >
                    {nome}
                </Link>
            );
        },
        meta: {
            headerProps: { style: { width: 350 }, className: 'ps-4' },
            cellProps: { className: 'ps-4' }
        }
    },
    {
        accessorKey: 'uf',
        header: 'UF',
        meta: {
            headerProps: { style: { width: 80 } },
        }
    },
    {
        accessorKey: 'tipoConselho',
        header: 'Conselho',
        cell: ({ row: { original } }) => getTipoConselhoLabel(original.tipoConselho),
        meta: {
            headerProps: { style: { width: 150 } },
        }
    },
    {
        accessorKey: 'registro',
        header: 'Registro',
        meta: {
            headerProps: { style: { width: 150 } },
        }
    },
    {
        id: 'action',
        cell: () => (
            <RevealDropdownTrigger>
                <RevealDropdown>
                    <ActionDropdownItems />
                </RevealDropdown>
            </RevealDropdownTrigger>
        ),
        meta: {
            headerProps: { style: { width: '7%' } },
            cellProps: { className: 'text-end' }
        }
    }
];

const MedicoTable = () => {
    return (
        <div>
            <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />
            <AdvanceTableFooter pagination showViewAllBtn={false} />
        </div>
    );
};

export default MedicoTable; 